export default "__VITE_ASSET__CxKrUE7R__"